
<div class="popup-model popup-lg shadow top" [ngClass]="selectedOperationalCategory || estModif ? '':'minimal-height' ">
  <div class="d-flex justify-content-between align-items-center pink-header P-2">
    @if (!estModif) {
      <h5 class="flex-grow-1 text-center mt-1">{{'GLOBAL.ADD_BLAST' | translate}}</h5>
    }
    @if (estModif) {
      <h5 class="flex-grow-1 text-center mt-1">{{'GLOBAL.EDIT_BLAST' | translate}}</h5>
    }
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="onClose()">
        <img src="assets/icon/close.svg" />
      </button>
    </div>
  </div>
  <div class="p-4">
    @if (!estModif) {
      <div class="form-group input-select">
        <label for="selectProjet" class="text-label text-center">Operational category</label>
        <ng-select name="selectOperationalCategory"
          id="selectOperationalCategory"
          [items]="operationalCategories"
          bindLabel="nom"
          [(ngModel)]="selectedOperationalCategory"
          [multiple]="false"
          [disabled]="isOperationalCategoryDisabled"
          (change)="onOperationalCategoryChange()"
          [closeOnSelect]="true"
          [clearable]="false"
          [searchable]="!isOperationalCategoryDisabled"
          [clearOnBackspace]="true"
          [addTag]="false"
          class="searchable-select"
          [class.disabled]="isOperationalCategoryDisabled"
          [appendTo]="'body'"
          [dropdownPosition]="'auto'"
          >
        </ng-select>
      </div>
    }
    @if (selectedOperationalCategory || estModif) {
      <div>
        @if (!estModif) {
          <div class="mb-3">
            <div class="row col-md-12">
              <div class="col-md-3 pl-0">
                <div class="w-100">
                  <ul class="nav nav-tabs not-selectable w-100">
                    <li class="nav-item epc-tab col-md-6 p-0 pr-1" [ngClass]="viewTab == 'GENERAL' ? 'active':'' ">
                      <a class="nav-link text-center" (click)="viewTab = 'GENERAL'" [ngClass]="viewTab == 'GENERAL' ? 'active':'' ">General</a>
                    </li>
                    @if (shouldShowKpiTab()) {
                      <li class="nav-item epc-tab col-md-6 p-0 pl-1" [ngClass]="viewTab == 'KPI' ? 'active':'' ">
                        <a class="nav-link text-center" (click)="viewTab = 'KPI'" [ngClass]="viewTab == 'KPI' ? 'active':'' ">
                          KPI
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        }
        <form id="myForm" (ngSubmit)="onSubmit()">
          <div [hidden]="viewTab !== 'GENERAL'" class="tab-content-container">
            <div class="scrollable-tab-content">
              <div class="row">
                @if (tabProjets.length > 0) {
                  <div class="col-md-4">
                    <div class="form-group input-select">
                      <label for="selectProjet" class="text-label text-center">{{'GLOBAL.PROJET'| translate}}</label>
                      <ng-select name="selectProjet"
                        id="selectProjet"
                        [items]="tabProjets"
                        bindLabel="nom"
                        bindValue="projetId"
                        [(ngModel)]="tir.projetId"
                        [multiple]="false"
                        [closeOnSelect]="true"
                        [clearable]="true"
                        [searchable]="true"
                        [clearOnBackspace]="true"
                        [addTag]="false"
                        [appendTo]="'body'"
                        [dropdownPosition]="'auto'"
                        >
                      </ng-select>
                    </div>
                  </div>
                }
                <div [ngClass]="estModif ? 'col-md-6' : 'col-md-4'">
                  <div class="form-group">
                    <label for="nomTir" class="text-label text-center">{{'GLOBAL.NOM' | translate}}</label>
                    <input (focusout)="onFocusOutEvent(nomTir.value)" id="nomTir" #nomTir type="text" [(ngModel)]="tir.nom" name="nomTir" class="input-text" placeholder="{{'GLOBAL.NOM' | translate}}" maxlength="150" autocomplete="off" />
                    @if (nomInvalide) {
                      <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                    }
                    @if (nameAlreadyExists) {
                      <div class="custom-alert custom-alert-sm">{{'GLOBAL.NAME_EXIST' | translate}}</div>
                    }
                    @if (isForbidenCharacters) {
                      <div class="custom-alert custom-alert-sm">{{'GLOBAL.FORBIDDEN_CHARACTERS' | translate}}</div>
                    }
                  </div>
                </div>
                <div [ngClass]="estModif ? 'col-md-6' : 'col-md-4'">
                  <div class="form-group input-select">
                    <label for="selectType" class="text-label text-center">{{'MODALE_DONNEE_SUIVI.TYPE' | translate}}</label>
                    <ng-select name="selectType"
                      id="selectType"
                      [items]="tabTypeTirs"
                      bindLabel="nom"
                      [(ngModel)]="typeTirSelectionne"
                      [addTag]="true"
                      [hideSelected]="false"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      [clearOnBackspace]="true"
                      [appendTo]="'body'"
                      [dropdownPosition]="'auto'"
                      >
                    </ng-select>
                    @if (typeTirInvalide) {
                      <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group input-select">
                    <label for="selectZone" class="text-label text-center">{{'GLOBAL.ZONE' | translate}}</label>
                    <ng-select [items]="tabZones"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      [clearOnBackspace]="true"
                      bindLabel="nom"
                      placeholder="{{'GLOBAL.ZONE' | translate}}"
                      name="selectZone"
                      id="selectZone"
                      [(ngModel)]="zoneSelectionnee"
                      [addTag]="false"
                      [appendTo]="'body'"
                      [dropdownPosition]="'auto'">
                    </ng-select>
                    @if (zoneInvalide) {
                      <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                    }
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="niveau" class="text-label text-center">{{'GLOBAL.NIVEAU' | translate}}</label>
                    <input id="niveau" type="text" [(ngModel)]="niveauTir" name="niveau" class="input-text" placeholder="{{'GLOBAL.NIVEAU' | translate}}" autocomplete="off" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="datePrev" class="text-label text-center">{{'TIR.DATE_PREV' | translate}}</label>
                    <div class="input-group position-relative">
                      <input placeholder="{{'TIR.DATE_PREV' | translate}}"
                        onkeydown="return false"
                        type="text"
                        class="input-text input-calendar-icon"
                        [(ngModel)]="tir.dateTirPrevisionnelle"
                        name="datePrev"
                        id="datePrev"
                        [matDatepicker]="datePrevPicker"
                        [min]="datePrevDebutProjet"
                        [max]="datePrevFinProjet"
                        (click)="datePrevPicker.open()"
                        (focus)="datePrevPicker.open()"
                        readonly
                        autocomplete="off">
                        <mat-datepicker #datePrevPicker></mat-datepicker>
                        @if (tir.dateTirPrevisionnelle && !estModif) {
                          <i
                            class="fas fa-times position-absolute"
                            style="right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; z-index: 10;"
                          (click)="nettoyerDates('dateTirPrevisionnelle')"></i>
                        }
                      </div>
                      @if (datePrevInvalide) {
                        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                      }
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="dateEff" class="text-label text-center">{{'TIR.DATE_EFF' | translate}}</label>
                      <div class="input-group">
                        <input placeholder="{{'TIR.DATE_EFF' | translate}}"
                          type="text"
                          class="input-text input-calendar-icon"
                          [(ngModel)]="tir.dateTirEffective"
                          name="dateEff"
                          id="dateEff"
                          [matDatepicker]="dateEffPicker"
                          onkeydown="return false"
                          (click)="dateEffPicker.open()"
                          (focus)="dateEffPicker.open()"
                          readonly
                          autocomplete="off"
                          [min]="dateEffDebProjet"
                          [max]="dateEffFinProjet">
                          <mat-datepicker #dateEffPicker></mat-datepicker>
                          @if (tir.dateTirEffective && !estModif) {
                            <i
                              class="fas fa-times position-absolute"
                              style="right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; z-index: 10;"
                            (click)="nettoyerDates('dateTirEffective')"></i>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group input-select input-time-icon">
                        <label for="HeureEff" class="text-label text-center">{{'GLOBAL.HOUR' | translate}}</label>
                        <ng-select name="HeureEff"
                          id="HeureEff"
                          [clearable]="false"
                          [searchable]="false"
                          [items]="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]"
                          [(ngModel)]="HeureEff"
                          [multiple]="false"
                          [closeOnSelect]="true"
                          [appendTo]="'body'"
                          [dropdownPosition]="'auto'">
                          <ng-template ng-label-tmp ng-option-tmp let-item="item">
                            <span>{{ isFrench ? (item < 10 ? '0' + item : item) + ':00' : (item % 12 === 0 ? 12 : item % 12) + ':00 ' + (item < 12 ? 'AM' : 'PM') }}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  @if (shouldShowDragDropZone() && !estModif) {
                    <div class="row">
                      <div class="col-md-12">
                        <div class="drag-drop-zone"
                          [ngClass]="{'drag-over': isDragOver}"
                          (dragover)="onDragOver($event)"
                          (dragleave)="onDragLeave($event)"
                          (drop)="onDrop($event)"
                          (click)="triggerFileInput()">
                          <div class="drag-drop-content">
                            <i class="fas fa-cloud-upload-alt fa-3x mb-3"></i>
                            <p class="mb-2 drag-text"><strong>{{'GENERAL_TAB.DRAG_AND_DROP' | translate}}</strong></p>
                            <p class="text-muted">{{'GENERAL_TAB.CLICK_TO_SELECT' | translate}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (erreurApi) {
                    <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
                  }
                  @if (estModif) {
                    <div class="btn-toolbar justify-content-between">
                      <div class="d-flex align-items-center justify-content-start">
                        <div class="switch2">
                          <input id="isDeleted" type="checkbox" [(ngModel)]="isDeleted" name="isDeleted" />
                          <label for="isDeleted"></label>
                        </div>
                        <b>
                          {{'GLOBAL.SUPPRIMER_BLAST' | translate}}
                        </b>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div [hidden]="viewTab !== 'KPI'" class="tab-content-container">
                <div class="scrollable-tab-content">
                  @if (configAnalysis && configAnalysis.length > 0) {
                    <div>
                      @for (rowKpis of kpiRows; track rowKpis; let rowIndex = $index) {
                        <div>
                          @if (rowKpis.length === 1 && rowKpis[0].isCategory) {
                            <div class="d-flex align-items-center mb-4 mt-3">
                              <h5 class="mb-0 me-3">{{ rowKpis[0].categoryName }}</h5>
                              <hr class="flex-grow-1 mb-0">
                            </div>
                          }
                          @if (!rowKpis[0]?.isCategory) {
                            <div class="row">
                              @for (kpi of rowKpis; track kpi; let colIndex = $index) {
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label [for]="'kpi_' + kpi.referentielDonneeAnalyseId" class="text-label text-center">
                                      {{ kpi.referentielDonneeAnalyse.nom }}
                                    </label>
                                    <!-- Champ de saisie pour InputText -->
                                    @if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'InputText') {
                                      <div style="position: relative;">
                                        <input
                                          [id]="'kpi_' + kpi.referentielDonneeAnalyseId"
                                          type="text"
                                          [(ngModel)]="kpi.valeurSaisie"
                                          [name]="'kpi_input_' + kpi.referentielDonneeAnalyseId"
                                          class="input-text"
                                          autocomplete="off"
                                          style="padding-right: 80px;" />
                                          <span style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #6c757d; pointer-events: none;">{{ kpi.referentielDonneeAnalyse.nomUniteReferentiel }}</span>
                                        </div>
                                      }
                                      <!-- Toggle pour YesOrNo -->
                                      @if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'YesOrNo') {
                                        <div class="toggle-container">
                                          <div class="toggle-switch">
                                            <input
                                              [id]="'kpi_toggle_' + kpi.referentielDonneeAnalyseId"
                                              type="checkbox"
                                              [(ngModel)]="kpi.valeurBooleen"
                                              [name]="'kpi_toggle_' + kpi.referentielDonneeAnalyseId"
                                              class="toggle-input" />
                                              <label [for]="'kpi_toggle_' + kpi.referentielDonneeAnalyseId" class="toggle-label">
                                                <span class="toggle-slider"></span>
                                              </label>
                                            </div>
                                            <span class="toggle-text">{{ kpi.valeurBooleen ? 'Oui' : 'Non' }}</span>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="d-flex justify-content-center pt-3 pb-3" style="gap: 20px;">
                    <button type="button" class="btn btn-outline-primary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
                    <button type="submit" class="btn primary-button">
                    {{'GLOBAL.VALIDER' | translate}}</button>
                  </div>
                </form>
              </div>
            }

            <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
              <div class="modal-dialog modal-sm">
                <div class="modal-content">
                  <div class="custom-overlay"></div>
                  <div class="modal-body text-center">
                    <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
                    <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
                    <button type="button" class="btn btn-secondary" (click)="modalConfirmSuppr.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>

            <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
              <div class="modal-dialog modal-sm">
                <div class="modal-content">
                  <div class="custom-overlay"></div>
                  <div class="modal-body text-center">
                    <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
                    <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
                    <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <input #fileInput type="file" multiple style="display: none;" (change)="filesFromInput($event)" accept="*/*" />